import { render, staticRenderFns } from "./TopJettons.vue?vue&type=template&id=0812aa1c"
import script from "./TopJettons.vue?vue&type=script&lang=js"
export * from "./TopJettons.vue?vue&type=script&lang=js"
import style0 from "./TopJettons.vue?vue&type=style&index=0&id=0812aa1c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports